import React, { Component } from 'react';
import PubSub from 'pubsub-js';

export default class Select extends Component {

    constructor() {
        super();
        this.state = { msgErro: '' };
    }

    render() {
        return (
            <div>

                <select {...this.props}>
                    <option>Escolha uma opção</option>
                    {
                        this.props.values.map(option => {
                            return (
                                <option key={option.id} value={option.id}>{option.nome}</option>
                            );
                        })
                    }
                </select>
                <label htmlFor={this.props.id}>{this.props.label}</label>
                <span className="error">{this.state.msgErro}</span>
            </div>
        );
    }


    componentDidMount() {
        PubSub.subscribe('erro-validacao', function (topico, erro) {
            if (erro.field === this.props.name) {
                this.setState({ msgErro: erro.defaultMessage });
            }
        }.bind(this));

        PubSub.subscribe('limpa-erros', function (topico) {
            this.setState({ msgErro: '' });
        }.bind(this));
    }

}


// WEBPACK FOOTER //
// ./src/components/Select.js